/*
#############################################################################
# Copyright (c) 2022-2023 NVIDIA CORPORATION & AFFILIATES. All rights reserved.
#
# NVIDIA CORPORATION, its affiliates and licensors retain all intellectual
# property and proprietary rights in and to this material, related
# documentation and any modifications thereto. Any use, reproduction,
# disclosure or distribution of this material and related documentation
# without an express license agreement from NVIDIA CORPORATION or
# its affiliates is strictly prohibited.
###############################################################################
*/

/* eslint-disable no-console */
import React from "react";
import { useSelector } from "react-redux";
import Box from "@mui/material/Box";
import Typography from '@mui/material/Typography';
import { useLocation } from "react-router-dom";

function WaitingMessage() {
  const sessionActive = useSelector((state) => state.uuid.sessionActive);
  const location = useLocation().pathname;
  const shouldRenderMessage = 
    !sessionActive &&
    location === "/WELCOME_VIEW";
  // Please move in view of the camera to start your order
  return (
    <Box sx={{
      display: shouldRenderMessage ? "inline" : "none",
      justifyContent: "center",
      width: "100%",
    }}>
      <Typography 
        align='center'
        color='#77b900'
        fontSize='18px'
        sx={{
          p: 3.7,
        }}>Please move in view of the camera to start your order</Typography>
    </Box>
  );
}

export default WaitingMessage;